module.exports = __webpack_public_path__ + "media/images/claim_profile/Group 16-4a9d202a900b5e82885859b17d1c4625.png";